// extracted by mini-css-extract-plugin
export default {"search_wrapper":"Search_search_wrapper__P984w","search_icon":"Search_search_icon__5C5PW","clearinput_icon":"Search_clearinput_icon__7fC7C","input":"Search_input__klILD"};